import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import hdpe from '../assets/images/warehouse-hdpe.jpg';
import lldpe from '../assets/images/warehouse-lldpe.jpg';
import lyb from '../assets/images/lyondellbasell-bag.jpg';
import './Warehouse.css';

export default function Warehouse() {
  const { t } = useLanguage();

  return (
    <section id="warehouse" className="section warehouse">
      <div className="container">
        <div className="section-head section-head--center">
          <span className="kicker">{t.warehouse.kicker}</span>
          <h2 className="section-title">{t.warehouse.title}</h2>
          <p className="warehouse__desc">{t.warehouse.desc}</p>
        </div>
        <div className="warehouse__gallery">
          <div className="warehouse__item warehouse__item--tall">
            <img src={hdpe} alt="HDPE bags stacked in warehouse" loading="lazy" />
          </div>
          <div className="warehouse__item">
            <img src={lldpe} alt="LLDPE 25kg bags" loading="lazy" />
          </div>
          <div className="warehouse__item">
            <img src={lyb} alt="LyondellBasell Polyolefins raw material bag" loading="lazy" />
          </div>
        </div>
      </div>
    </section>
  );
}
